import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Format Italic"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-format-italic',
    templateUrl: './icon-format-italic.component.html',
    styleUrls: ['./icon-format-italic.component.scss'],
    standalone: false
})
export class IconFormatItalicComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
